import { SECONDARY_CTA_STYLE as sec } from './style'
import { BRAND } from '../../constants'
const { media } = BRAND

type SecondaryCTAProps = {
  secondaryCta: SecondaryCTAType
  collectionId: number
}

type SecondaryCTAType = {
  title: string
  blurb: string
  cta: string
}

export const SecondaryCTA = ({ secondaryCta, collectionId }: SecondaryCTAProps) => {
  const { title, blurb, cta } = secondaryCta
  const query = collectionId ? `?collection=${collectionId}` : ''

  return (
    <section>
      <div className='banner'>
        <section className='card'>
          <h3 style={sec.title}>{title}</h3>
          <p style={sec.paragraph}>{blurb}</p>
          <a
            id='#secondary-cta'
            tabIndex={1}
            style={sec.button}
            href={`${process.env.NEXT_PUBLIC_BRIEF_BUILDER}${query}`}>
            {cta}
          </a>
        </section>
        <div className='img'>
          <img
            alt={title}
            aria-hidden={true}
            height='0.55'
            width='1'
            src={`/ilp-public/assets/images/messagesIcon.png`}
          />
        </div>
        <style jsx>{`
            .banner {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                flex-direction: row;
                justify-content: center;
                width: 1230px;
                max-width: 1230px;
                min-height: 330px;
                background-color: #AF231C,
                border-radius: 20;
                margin: '40px 0px';
            }
            .card {
                max-width: 400;
                height: 330;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-direction: column;
                padding: 10px;
            }
            .img {
                object-fit: cover;
                height: 330px;
                width: 500px;
                padding-top: 20px;
            }
            @media screen and (max-width: ${media.average}px) {
                .img {
                height: 310px;
                }
            }
            @media screen and (max-width: ${media.medium}px) {
                .img {
                height: 280px;
                padding-top: 10px;
                }
            }
            @media screen and (max-width: ${media.small}px) {
                .img {
                padding: 0px;
                height: 230px;
                }
            }
        `}</style>
      </div>
    </section>
  )
}
